<template>
<div class="card flex-grow-1">
	<div class="card-header border-bottom">
		<h5 class="header-case">{{__('Sentiment Trends')}}</h5>
	</div>
	<div class="card-body p-0">
		<div class="pinned-trends" v-if="false">
			<p class="blue-text p-3">
				<i class="fas fa-thumbtack"></i>
				<span class="header-case">PINNED TOPICS</span>
			</p>
			<div class="metrics row justify-content-center">
				<div class="col-md-2 border-right" v-for="pin in pins">
					<p class="metric-label text-center">
						<strong>{{ pin | capitalize }}</strong>
					</p>
					<div class="d-flex">
						<div class="face-stat-wrapper">
							<div class="face face-lite d-inline-block mr-1 danger"></div>
							<span class="metric-number text-center">{{ pinned[pin].negative.length > 0 ? pinned[pin].negative[0].total : 0  }}</span>
						</div>
						<div class="face-stat-wrapper">
							<div class="face face-lite d-inline-block mr-1 success"></div>
							<span class="metric-number text-center">{{ pinned[pin].positive.length > 0 ? pinned[pin].positive[0].total : 0  }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="sentiment-trends border-top">
            <div class="d-flex flex-wrap">
                <div class="w-50 d-flex flex-wrap justify-content-center p-4 border-right positive-terms" ref="positive">
					<div class="bubble"
						@click="expandTrend(term.target, term.category, 'positive')"
						v-for="term in positiveTerms"
						:class="{active: activeType == 'positive' && activeTarget == term.target}"
					>
						<span class="title">{{ term.target | capitalize }}</span>
						<span class="number text-success">{{ term.total }}&nbsp;<i class="far fa-comment"></i></span>
						<span class="extension" v-if="activeType == 'positive' && activeTarget == term.target"
							:style="extensionStyle"
							:class="{nothing: setRightWidth(activeTarget)}"
						>
							<span class="extension-y" v-if="activeType == 'positive' && activeTarget == term.target"
							:class="{nothing: setRightWidth(activeTarget)}"
							:style="{height: rightHeight + 'px'}"
							></span>
						</span>

					</div>
                </div>
                <div class="w-50 d-flex flex-wrap justify-content-center p-4 negative-terms" ref="negative">
                    <div class="bubble"
                    	@click="expandTrend(term.target, term.category, 'negative')"
                    	v-for="term in negativeTerms"
                    	:class="{active: activeType == 'negative' && activeTarget == term.target}"
                	>
						<span class="title">{{ term.target | capitalize }}</span>
						<span class="number text-danger">{{ term.total }}&nbsp;<i class="far fa-comment"></i></span>
						<span class="extension" v-if="activeType == 'negative' && activeTarget == term.target"
							:style="extensionStyle"
							:class="{nothing: setRightWidth(activeTarget)}"
						>
							<span class="extension-y" v-if="activeType == 'negative' && activeTarget == term.target"
							:class="{nothing: setRightWidth(activeTarget)}"
							:style="{height: rightHeight + 'px'}"
							></span>
						</span>
					</div>
                </div>
            </div>
            <div class="quotes-circle" :class="{'border-success': activeType == 'positive', 'border-danger': activeType == 'negative'}">
                <img src="/assets/img/1.0/quotes.png" alt="Quotes"/>
            </div>
        </div>
        <div class="trends-specific">
        	<div class="d-flex justify-content-center mb-3 metrics align-items-center" v-if="activeType && activeTarget">
        		<div class="">
	        		<p class="text-center">
	        			<span class="header-case">MENTIONS</span>
        				<span class="badge brand-primary-badge">{{ activeTerm.total }}</span><br>
    					<a href="#" class="blue-link header-case" @click.prevent="goToReviews(activeTerm)">Go to reviews</a>
	        		</p>
        			<p>
		        		<span class="special-badge d-block special-badge-point" :class="{'special-badge-success': activeType == 'positive', 'special-badge-danger': activeType == 'negative'}">
		        			{{ activeTarget | capitalize }}
		        		</span>
	        		</p>
        		</div>
        		<div>

        		</div>
        	</div>
        	<insight-trends-chart :trends="activeTrends" :responsive="true" :type="activeType"></insight-trends-chart>
        </div>
	</div>
</div>
</template>

<script>
export default {
	props: ['fromDate', 'toDate'],
	watch: {
		fromDate: function(newValue, oldValue) {
			if (newValue) {
				this.loadTrends()
				if (this.activeTarget) {
					this.expandTrend(this.activeTarget, this.activeCategory, this.activeType)
				}
			}
		}
	},
	computed: {
		pinned() {
			let pinned = {}

			for (let target of this.pins) {
				pinned[target] = this.findPinned(target)
			}

			return pinned
		},
		activeTerm() {

			if (! this.activeType || ! this.activeTarget) {
				return {}
			}


			let foundTerms = []
			if (this.activeType == 'positive') {
				foundTerms = this.positiveTerms.filter(term => {
					return term.target == this.activeTarget
				})
			} else {
				foundTerms = this.negativeTerms.filter(term => {
					return term.target == this.activeTarget
				})
			}

			if (foundTerms.length > 0) {
				return foundTerms[0]
			}

			return {}

		},
		positiveTerms() {
			if (this.trends.terms) {
				return this.trends.terms.positive.splice(0, 9)
			}

			return []
		},
		negativeTerms() {
			if (this.trends.terms) {
				return this.trends.terms.negative.splice(0, 9)
			}

			return []
		},
		extensionStyle() {
			let req = this.activeTarget

			let style = {
				width: this.rightWidth + 'px'
			}

			if (this.activeType == 'positive') {
				style.right = '-' + this.rightWidth + 'px'
			} else {
				style.left = '-' + this.rightWidth + 'px'
			}

			return style
		},
		extensionYStyle() {
			let req = this.activeTarget

			return {
				right: '-' + this.rightWidth + 'px'
			}
		}
	},
	data() {
		return {
			trends: {},
			activeTrends: null,
			activeType: null,
			activeTarget: '',
			activeCategory: '',
			pins: ['wifi', 'bar', 'bathroom', 'entertainment', 'view'],
			terms: [
				'hotel',
				'room',
				'staff',
				'food',
				'location',
				'breakfast',
				'view',
				'pool',
				'restaurant',
				'service',
				'bed',
				'beach',
				'bar',
				'bathroom',
				'price',
				'resort',
				'value',
				'shower',
				'wifi',
				'reception',
				'entertainment',
				'areas',
				'towel',
				'buffet',
				'meal',
				'balcony',
				'spa',
				'atmosphere',
				'parking',
				'evening',
				'space',
				'cocktail',
				'dishes',
				'coffee',
				'wine',
				'terrace',
				'building',
				'music',
				'breakfast',
				'dinner',
				'drink',
				'fruit',
				'table',
				'decor',
				'lobby',
				'garden',
				'tv',
				'roof',
				'check-in',
				'internet'
			],
			rightWidth: 0,
			rightHeight: 0
		}
	},
	methods: {
		goToReviews(term) {
			let type = term.score >= 0.5 ? 'positive' : 'negative'
			let data = {
				'terms': '',
				'keyword': term.target,
				// 'sentimentCategory': term.category,
				'fromDate': this.fromDate,
				'toDate': this.toDate,
				'positiveNegativeOrBoth': type
			}
			this.$eventHub.$emit('applyFilters', data)
			$('.spark-settings-tabs a[href$="#reviews"]').tab('show');
		},
		findPinned(target) {

			let positive = this.positiveTerms.filter(term => {
				return term.target == target
			})

			let negative = this.negativeTerms.filter(term => {
				return term.target == target
			})

			return {
				positive: positive,
				negative: negative
			}
		},
		setRightWidth(target) {
			let width = this.$refs[this.activeType].offsetWidth
			let height = this.$refs[this.activeType].offsetHeight
			let originX = this.$refs[this.activeType].getBoundingClientRect().left

			let originY = this.$refs[this.activeType].getBoundingClientRect().top

			let requirement = this.activeType
			let requirement2 = this.activeTarget

			var instance = this
			Vue.nextTick(function() {
				let elem = null
				if (instance.activeType == 'positive') {
					elem = instance.$refs.positive.querySelector('.active')
				} else {
					elem = instance.$refs.negative.querySelector('.active')
				}

				let elemWidth = elem.offsetWidth
				let elemHeight = elem.offsetHeight

				let x = elem.getBoundingClientRect().left - originX
				let y = elem.getBoundingClientRect().top - originY

				if (instance.activeType == 'positive') {
					instance.setNewRightWidth(width - (x + elemWidth))
				} else {
					instance.setNewRightWidth(x)
				}

				instance.setNewRightHeight(height - (y + elemHeight))
			})

			return 0

		},
		setNewRightWidth(newWidth) {
			this.rightWidth = newWidth
		},
		setNewRightHeight(newHeight) {
			this.rightHeight = newHeight + 15
		},
		expandTrend(keyword, category, type) {
			let params = {
				fromDate: this.fromDate,
				toDate: this.toDate,
				keyword: keyword,
				category: category
			}
			let url = `/api/insights/${Spark.state.currentTeam.id}/all/trend`


			axios.get(url, {params: params}).then(response => {
				this.activeType = type
				this.activeTrends = response.data
				this.activeTarget = keyword
				this.activeCategory = category
			})
		},
		loadTrends() {
			let params = {
				fromDate: this.fromDate,
				toDate: this.toDate
			}
			axios.get(`/api/overview/${Spark.state.currentTeam.id}/trends`, {params: params}).then(response => {
				this.trends = response.data
			})
		}
	}
};
</script>
